var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnhappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 219,
    viewBox: "0 0 219 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 21C53.299 21 58 16.299 58 10.5C58 4.70101 53.299 0 47.5 0C41.701 0 37 4.70101 37 10.5C37 16.299 41.701 21 47.5 21Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 21C179.299 21 184 16.299 184 10.5C184 4.70101 179.299 0 173.5 0C167.701 0 163 4.70101 163 10.5C163 16.299 167.701 21 173.5 21Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 204C155.063 204 192 167.063 192 121.5C192 75.9365 155.063 39 109.5 39C63.9365 39 27 75.9365 27 121.5C27 167.063 63.9365 204 109.5 204Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 98H0V219H219V98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 108C46.1348 108 50.5 103.747 50.5 98.5C50.5 93.2533 46.1348 89 40.75 89C35.3652 89 31 93.2533 31 98.5C31 103.747 35.3652 108 40.75 108Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75 108C184.135 108 188.5 103.747 188.5 98.5C188.5 93.2533 184.135 89 178.75 89C173.365 89 169 93.2533 169 98.5C169 103.747 173.365 108 178.75 108Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 189C145.899 189 175 159.899 175 124C175 88.1015 145.899 59 110 59C74.1015 59 45 88.1015 45 124C45 159.899 74.1015 189 110 189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 219,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappy);
export default __webpack_public_path__ + "static/media/unhappy.e5db3817e705fa02824bb3f18a8be9f8.svg";
export { ForwardRef as ReactComponent };